import { render, staticRenderFns } from "./SaquesTable.vue?vue&type=template&id=80484202&"
import script from "./SaquesTable.vue?vue&type=script&lang=ts&"
export * from "./SaquesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports